<template>
    <div class="wrapper-form-block-enderecoEmpresarial" :class="{'allow-markup-error': markupError}" :inert="pPreview">
      <TrfNumberInput
        label="Qual o número do IPTU da empresa?"
        placeholder="IPTU da empresa"
        margin="0"
        id="form-block-empresa-iptu"
        v-model="formData.iptuEmpresa"
        maxLength="20"
        ref="BlockEmpresaIPTU"
        v-e2e="'form-block-empresa-iptu'"
        :required="required"
        @update:model-value="(iptuEmpresa) => setIptuEmpresa(iptuEmpresa)"
      ></TrfNumberInput>
      <p class="error-message" v-if="isInvalida">
        Campo obrigatório!
      </p>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
  export default {
    name: 'TrfBlocoIptuEmpresarial',
    emits: ['update:form-data', 'set:validacao'],
    components: {
        TrfNumberInput: defineAsyncComponent(() => import('../../Input/TrfNumberInput.vue')),
    },
    props: {
        pIptuEmpresa: {
            type: String,
            default: ''
        },
        pPreview: {
            type: Boolean,
            default: true
        },
        pEmpresa: {
          type: Object,
          default: () => {}
        },
        pIsDirty: {
          type: Boolean,
          default: false
        },
        required: {
          type: Boolean,
          default: false
        }
    },
    data() {
      return {
        formData: {
            iptuEmpresa: this.pEmpresa?.iptuEmpresa? `${this.pEmpresa.iptuEmpresa}` : this.pIptuEmpresa
        },
        isDirty: this.pIsDirty
      };
    },
    computed: {
        isInvalida() {
          if (!this.required) return false;
          return this.isDirty && !this.formData.iptuEmpresa
        },
        markupError() {
          return !this.pPreview && this.isInvalida
        }
    },
    watch: {
        pIsDirty: {
            immediate: true,
            handler(novo) {
                this.isDirty = novo
            }
        },
        isInvalida: {
            immediate: true,
            handler(novo) {
                if(this.required) {
                    this.$emit('set:validacao', !novo);
                }
            }
        }
    },
    methods: {
        setIptuEmpresa(iptuEmpresa) {
          this.formData.iptuEmpresa = iptuEmpresa;
          this.emitFormData(this.formData)
          this.isDirty = true;
        },
        emitFormData(value = this.formData) {
            this.$emit('update:form-data', value)
        }
    }
  };
  </script>
  